import CalendarService from '../lib/services/CalendarService';
import { injectLogos } from '../lib/utils';

const fetchConferenceCall = (params = {}, injectTickersLogos = true, pageSize = 1000): Promise<any> => {
  const query = {
    ...params,
    pagesize: pageSize,
  };

  const Calendar = new CalendarService();

  return Calendar.getConferenceCalls(query).then(({ data }: any) => {
    const items: any = [];
    if (Array.isArray(data.conference) && data.conference.length) {
      return injectTickersLogos ? injectLogos(data.conference) : data.conference;
    }
    return items;
  });
};

export { fetchConferenceCall };
